import { render } from "./ManageTenants.vue?vue&type=template&id=005bbb20&scoped=true"
import script from "./ManageTenants.vue?vue&type=script&lang=js"
export * from "./ManageTenants.vue?vue&type=script&lang=js"

import "./ManageTenants.vue?vue&type=style&index=0&id=005bbb20&scoped=true&lang=css"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005bbb20"]])

export default __exports__